<div style="position:relative" class="header-container">
  <div class="logo-container account">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo"  (click)="navigateHome()"><img src="assets/logo.png"/></a>
  </div>
 
</div>

<div class="header-container">

 

  <div class="headerMenu">

	<div>

	<div class="retentionWrap">
		<app-retention-badge [retention]="authService.retentionStatus"></app-retention-badge>
	</div>

	<!-- Standing in the row with the other items rather than inside the badge
	     wrapper beside it: it now has their shape, so it should have their
	     spacing and their baseline too. -->
	<app-storage-badge></app-storage-badge>

	<div class="headerMenuItem"    >
  <div class="lbl"><span>Баланс</span> <a href="javascript:;" (click)="goTo('/expenses')" >Історія</a></div>
  <div class="middle">
<div class="menuItemIcon"><nb-icon icon="credit-card-outline"></nb-icon></div>
<div [class.danger]="authService.balance < 0" class="menuItemText">{{authService.balance | number:'1.2'}} грн</div>
  </div>

  <div class="bottom">
<a href="javascript:;" (click)="openPayModal()" ><span class="txt">Поповнити</span> <span class="mobicon"> <nb-icon class="caret" icon="plus-square-outline"></nb-icon> </span></a>

  </div>
</div>
 


  
	<div class="headerMenuItem"   >
  <div class="lbl"><span>Ваш тариф</span></div>
  <div class="middle">
<div  [ngClass]="['menuItemIconTarrif', authService.currentTariff?.shortCode]" ></div>
<div class="menuItemText tarrif">{{authService.currentTariff?.title}}</div>
  </div>

  <div  style="cursor:pointer" nbContextMenuTag="balanceContextMenu" [nbPopover]="popoverExpenses" nbPopoverTrigger="click" nbPopoverPlacement="bottom" class="bottom">
<span >Змінити</span>
<nb-icon class="caret" icon="chevron-down-outline"></nb-icon>
  </div>
 
</div>



  
	<!-- Was "Прибутковий баланс": a platform wallet that receives nothing under the
	     agent model. Replaced by what the author actually wants to know - how much
	     was sold - with the split behind the popover. -->
	<div class="headerMenuItem"   >
  <div class="lbl"><span>Зараховано за 30 днів</span>  </div>
  <div class="middle">
<div class="menuItemIcon income"><i class="fa fa-university" aria-hidden="true"></i></div>
<div  class="menuItemText">{{(salesSummary?.last30?.net || 0) | number:'1.2'}} грн</div>
  </div>

  <div  style="cursor:pointer" nbContextMenuTag="balanceContextMenu" [nbPopover]="popoverSales" nbPopoverTrigger="click" nbPopoverPlacement="bottom"  class="bottom">
<span >Детальніше</span>
<nb-icon class="caret" icon="chevron-down-outline"></nb-icon>
  </div>
</div>



  </div>

</div>

 
 
  <nb-actions size="small">
 
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="authService?.userData?.name || ''"
               [picture]="authService?.userData?.picture">
      </nb-user>
    </nb-action> 
  </nb-actions>

	
</div>




<ng-template #popoverExpenses> 
	<div class="menuTarifsPopover">

		<div class="menuPopoverHead">
			<div class="title"><span>Ваш тариф:</span> <span [ngClass]="['icon', authService.currentTariff?.shortCode]"></span> <span class="tariff">{{authService.currentTariff?.title}}</span></div>
			<div class="link"><a href="javascript:;" (click)="goTo('/expenses')" >Історія</a></div>
		</div>
 
			<div class="menuPopoverSubHead">
				<div *ngIf="authService.currentTariff?.isFree" class="message">
					до 5 глядачів, 2 години трансляція, 2 години відео,
					7 днів зберігання<span *ngIf="authService.currentTariff?.saleFeePercent != null">,
					комісія з продажу {{authService.currentTariff?.saleFeePercent}}%</span>
				</div>
				<div *ngIf="!authService.currentTariff?.isFree && authService.currentTariff?.end_date" class="date"> 
					Діє до: {{ authService.currentTariff?.end_date | date:'dd.MM.y'}}
					
				</div>
			</div>



		<div *ngFor="let tariff of authService.tariffsList" [class.current]="tariff._id === authService.currentTariff?.tariffId" class="menuPopoverItem">


			  
				<div class="desc">
					<div [ngClass]="['icon', tariff.shortCode]"
></div>
					<div class="text">
					   <div class="title">{{tariff.title}}</div>
					  <div class="subtitle">{{tariff.shortDescription}}</div>
					  <div class="subtitle" *ngIf="tariff.storageQuotaGb">{{tariff.storageQuotaGb}} ГБ</div>
					  <!-- The offer promises the per-plan commission is published; it lives in
					       tariffs.saleFeePercent and now travels with the plan, so this is the
					       same number the invoice will charge, not a copy of it. -->
					  <div class="subtitle" *ngIf="tariff.saleAvailable && tariff.saleFeePercent != null">комісія з продажу {{tariff.saleFeePercent}}%</div>
					</div>
				</div>
  				<div class="action">
					<div class="button">
						<button size="small" fullWidth [disabled]="tariff._id === authService.currentTariff?.tariffId" (click)="openBuyTariffModal(tariff.shortCode)" nbButton [status]="tariff._id === authService.currentTariff?.tariffId ? 'success': 'primary'">
						{{tariff._id === authService.currentTariff?.tariffId ? 'Поточний': 'Активувати'}}
						</button>
					</div>

				        <div class="price">{{tariff.price}} грн</div>
				</div>
		 
			 
		</div>
 
	</div>
</ng-template>
 



<ng-template #popoverSales>
	<div class="menuPopover" style="min-width:290px;">

		<div class="menuPopoverHead">
			<div class="title">Продажі</div>
			<div class="link"><a (click)="goTo('/income')" href="javascript:;" >Історія</a></div>
		</div>

		<div style="display:flex; justify-content:space-between; align-items:baseline; margin:2px 0 12px;">
			<span style="font-size:12px; opacity:0.75;">Комісія сервісу за тарифом</span>
			<b style="font-size:13px; white-space:nowrap;">{{salesSummary?.feePercent}}%</b>
		</div>

		<div style="display:flex; justify-content:space-between; align-items:baseline;">
			<span style="font-size:13px;">За 30 днів</span>
			<b style="font-size:15px; white-space:nowrap;">{{(salesSummary?.last30?.net || 0) | number:'1.2'}} грн</b>
		</div>
		<div style="font-size:11px; opacity:0.7; margin:2px 0 12px;">
			продано {{(salesSummary?.last30?.sold || 0) | number:'1.2'}} грн ·
			{{salesSummary?.last30?.count || 0}} шт ·
			сервіс {{(salesSummary?.last30?.fee || 0) | number:'1.2'}} грн · банк {{(salesSummary?.last30?.bank || 0) | number:'1.2'}} грн
		</div>

		<div style="display:flex; justify-content:space-between; align-items:baseline;">
			<span style="font-size:13px;">За весь час</span>
			<b style="font-size:15px; white-space:nowrap;">{{(salesSummary?.total?.net || 0) | number:'1.2'}} грн</b>
		</div>
		<div style="font-size:11px; opacity:0.7; margin-top:2px;">
			продано {{(salesSummary?.total?.sold || 0) | number:'1.2'}} грн ·
			{{salesSummary?.total?.count || 0}} шт ·
			сервіс {{(salesSummary?.total?.fee || 0) | number:'1.2'}} грн · банк {{(salesSummary?.total?.bank || 0) | number:'1.2'}} грн
		</div>

	</div>
</ng-template>  


	











    
    
      
